(function () {
  function initViffWizardMk3() {
    var roots = document.querySelectorAll("[data-viff-wizard-root]");

    roots.forEach(function (section) {
      if (section.dataset.wizardReady === "true") return;
      section.dataset.wizardReady = "true";

      var FULL_PRICE_CENTS = 699;
      var MAX_STICKS = 5;

      var shopifyRoot = "/";

      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        shopifyRoot = window.Shopify.routes.root;
      }

      function cartUrl(path) {
        return shopifyRoot + String(path || "").replace(/^\//, "");
      }

      var productJsonTag = section.querySelector("[data-viff-product-json]");
      var productData = null;

      try {
        productData = JSON.parse(productJsonTag.textContent);
      } catch (error) {
        productData = { variants: [] };
      }

      var variants = productData.variants || [];
      var colourOrder = ["Green", "Blue", "Black", "Purple", "Pink"];

      var defaultAroma = "Mango";
      var defaultColour = "Green";

      var packSize = 3;
      var packPrice = "£13.98";
      var currentIndex = 0;
      var selections = [];
      var drawerMode = "preview";
      var builderMode = "custom";
      var discoveryScents = ["Menthol", "Mango", "Grape", "Lavender"];
      var savedModes = {};
      var discoveryPriceCents = Number(section.dataset.discoveryPrice || 1699);
      var discoveryReady = section.dataset.discoveryReady === "true";
      var modeButtons = section.querySelectorAll("button[data-builder-mode]");
      var customPacks = section.querySelector("[data-custom-packs]");
      var discoveryPack = section.querySelector("[data-discovery-pack]");
      var discoveryList = section.querySelector("[data-discovery-scents]");
      var scentSelector = section.querySelector("[data-scent-selector]");
      var fixedScent = section.querySelector("[data-fixed-scent]");
      var fixedScentIcon = section.querySelector("[data-fixed-scent-icon]");
      var fixedScentName = section.querySelector("[data-fixed-scent-name]");

      var packButtons = section.querySelectorAll("[data-pack-size]");
      var progress = section.querySelector("[data-wizard-progress]");
      var currentSmall = section.querySelector("[data-current-small]");
      var currentTitle = section.querySelector("[data-current-title]");
      var aromaButtons = section.querySelectorAll("[data-aroma]");
      var colourButtons = section.querySelectorAll("[data-colour]");
      var prevButton = section.querySelector("[data-prev-stick]");
      var nextButton = section.querySelector("[data-next-stick]");
      var reviewButton = section.querySelector("[data-review-pack]");
      var summary = section.querySelector("[data-summary-list]");
      var total = section.querySelector("[data-total-price]");
      var atcButton = section.querySelector("[data-real-atc]");
      var message = section.querySelector("[data-wizard-message]");

      var galleryMain = section.querySelector("[data-viff-gallery-main]");
      var galleryThumbs = section.querySelector("[data-viff-gallery-thumbs]");

      var drawer = section.querySelector("[data-viff-cart-drawer]");
      var drawerPill = section.querySelector("[data-drawer-pill]");
      var drawerTitle = section.querySelector("[data-drawer-title]");
      var drawerStatus = section.querySelector("[data-drawer-status]");
      var drawerLines = section.querySelector("[data-drawer-lines]");
      var drawerPrice = section.querySelector("[data-drawer-price]");
      var drawerPriceLabel = section.querySelector("[data-drawer-price-label]");
      var drawerNote = section.querySelector("[data-drawer-note]");
      var drawerAdd = section.querySelector("[data-drawer-add]");
      var drawerCheckout = section.querySelector("[data-drawer-checkout]");
      var drawerSecondary = section.querySelector("[data-drawer-secondary]");
      var closeDrawerButtons = section.querySelectorAll("[data-close-cart-drawer]");

      var viffAromaIcons = {
        Menthol: "https://cdn.shopify.com/s/files/1/0756/0544/2785/files/1_44b1e97a-1b06-4c4c-8491-00e3a4892638.png?v=1784731996",
        Mango: "https://cdn.shopify.com/s/files/1/0756/0544/2785/files/2_8a5f8a1f-fd9f-404c-9174-69aa5dc25ec9.png?v=1784731996",
        Grape: "https://cdn.shopify.com/s/files/1/0756/0544/2785/files/3_7305bd39-29de-4426-be07-e6748534b090.png?v=1784731996",
        Lavender: "https://cdn.shopify.com/s/files/1/0756/0544/2785/files/4_b8426a7e-29d9-4450-8bdd-1d3a01e4cbd3.png?v=1784731996"
      };

      function getViffAromaIcon(aroma) {
        return viffAromaIcons[aroma] || viffAromaIcons.Menthol;
      }

      function getViffColourClass(colour) {
        switch ((colour || "").toLowerCase()) {
          case "blue":
            return "viff-progress-pill--blue";
          case "black":
            return "viff-progress-pill--black";
          case "green":
            return "viff-progress-pill--green";
          case "purple":
            return "viff-progress-pill--purple";
          case "pink":
            return "viff-progress-pill--pink";
          default:
            return "viff-progress-pill--blue";
        }
      }

      function normalise(value) {
        return String(value || "").trim().toLowerCase();
      }

      function cleanMatch(value) {
        return String(value || "")
          .trim()
          .toLowerCase()
          .replace(/colour/g, "color")
          .replace(/[^a-z0-9]+/g, " ")
          .replace(/\s+/g, " ")
          .trim();
      }

      function valueContains(value, wanted) {
        value = cleanMatch(value);
        wanted = cleanMatch(wanted);

        if (!value || !wanted) return false;

        return value === wanted || value.indexOf(wanted) !== -1;
      }

      function formatMoney(cents) {
        var value = Number(cents || 0) / 100;
        return "£" + value.toFixed(2);
      }

      function cleanImage(image) {
        if (!image) return "";
        image = String(image);
        if (image.indexOf("//") === 0) return "https:" + image;
        return image;
      }

      function lineIsFree(index, count) {
        if (builderMode === "discovery" || count === 4) return false;
        if (count >= 5 && index >= 3) return true;
        if (count >= 3 && count < 5 && index === 2) return true;
        return false;
      }

      function lineFinalPrice(index, count) {
        if (builderMode === "discovery" || count === 4) {
          return Math.floor(discoveryPriceCents / 4) + (index < discoveryPriceCents % 4 ? 1 : 0);
        }
        return lineIsFree(index, count) ? 0 : FULL_PRICE_CENTS;
      }

      function cartPreviewTotalCents() {
        var totalCents = 0;

        for (var i = 0; i < selections.length; i++) {
          totalCents += lineFinalPrice(i, selections.length);
        }

        return totalCents;
      }

      function fetchCart() {
        return fetch(cartUrl("/cart.js"), {
          method: "GET",
          credentials: "same-origin",
          cache: "no-store",
          headers: {
            "Accept": "application/json"
          }
        }).then(function (response) {
          if (!response.ok) throw new Error("Cart fetch failed");
          return response.json();
        });
      }

      function updateCartBubble(count) {
        count = Number(count || 0);

        var selectors = [
          "#cart-icon-bubble",
          'a[href="/cart"]',
          'a[href="' + cartUrl("/cart") + '"]'
        ];

        var cartIconLinks = document.querySelectorAll(selectors.join(","));

        cartIconLinks.forEach(function (cartLink) {
          var bubble = cartLink.querySelector(".cart-count-bubble");

          if (!bubble && count > 0) {
            bubble = document.createElement("div");
            bubble.className = "cart-count-bubble";
            bubble.innerHTML =
              '<span aria-hidden="true">' + count + '</span>' +
              '<span class="visually-hidden">' + count + ' items</span>';

            cartLink.appendChild(bubble);
          }

          if (bubble) {
            bubble.style.display = count > 0 ? "" : "none";

            var visible = bubble.querySelector('span[aria-hidden="true"]');
            var hidden = bubble.querySelector(".visually-hidden");

            if (visible) visible.textContent = String(count);
            if (hidden) hidden.textContent = count + " items";

            if (!visible && !hidden) {
              bubble.textContent = String(count);
            }
          }
        });
      }

      function variantHasColour(variant, colour) {
        var wantedColour = normalise(colour);
        var value1 = normalise(variant.option1);
        var value2 = normalise(variant.option2);
        var value3 = normalise(variant.option3);
        var title = normalise(variant.title);

        return (
          value1 === wantedColour ||
          value2 === wantedColour ||
          value3 === wantedColour ||
          title.indexOf(wantedColour) !== -1
        );
      }

      function variantMatches(variant, aroma, colour) {
        var allValues = [
          variant.option1,
          variant.option2,
          variant.option3,
          variant.title
        ].join(" ");

        var hasAroma =
          valueContains(allValues, aroma) ||
          (aroma === "Menthol" && valueContains(allValues, "Mint")) ||
          (aroma === "Menthol" && valueContains(allValues, "Original"));

        var hasColour =
          valueContains(allValues, colour) ||
          (colour === "Blue" && valueContains(allValues, "Light Blue")) ||
          (colour === "Green" && valueContains(allValues, "Light Green")) ||
          (colour === "Purple" && valueContains(allValues, "Pastel Purple")) ||
          (colour === "Pink" && valueContains(allValues, "Pastel Pink"));

        return hasAroma && hasColour;
      }

      function getVariant(aroma, colour) {
        for (var i = 0; i < variants.length; i++) {
          if (variantMatches(variants[i], aroma, colour)) {
            return variants[i];
          }
        }

        for (var j = 0; j < variants.length; j++) {
          if (variantHasColour(variants[j], colour)) {
            return variants[j];
          }
        }

        return null;
      }

      function getGalleryVariantByColour(colour) {
        for (var i = 0; i < variants.length; i++) {
          if (variantHasColour(variants[i], colour) && variants[i].image) {
            return variants[i];
          }
        }

        return null;
      }

      function setGalleryImage(colour) {
        if (!galleryMain) return;

        var current = selections[currentIndex] || {};
        var variant = getVariant(current.aroma || defaultAroma, colour);
        var fallbackVariant = getGalleryVariantByColour(colour);
        var image = "";

        if (variant && variant.image) {
          image = variant.image;
        } else if (fallbackVariant && fallbackVariant.image) {
          image = fallbackVariant.image;
        } else {
          image = productData.featuredImage || galleryMain.src;
        }

        galleryMain.src = image;
        galleryMain.alt = "viff pocket inhaler in " + colour;
      }

      function renderGallery() {
        if (!galleryThumbs) return;

        var current = selections[currentIndex] || {};
        var currentColour = current.colour || defaultColour;

        galleryThumbs.innerHTML = "";

        colourOrder.forEach(function (colour) {
          var variant = getVariant(current.aroma || defaultAroma, colour);
          var fallbackVariant = getGalleryVariantByColour(colour);
          var image = "";

          if (variant && variant.image) {
            image = variant.image;
          } else if (fallbackVariant && fallbackVariant.image) {
            image = fallbackVariant.image;
          } else {
            image = productData.featuredImage || "";
          }

          var button = document.createElement("button");
          button.type = "button";
          button.className = "viff-gallery-thumb" + (colour === currentColour ? " is-active" : "");
          button.setAttribute("data-gallery-colour", colour);

          var img = document.createElement("img");
          img.src = image;
          img.alt = colour + " viff pocket inhaler";

          var label = document.createElement("span");
          label.textContent = colour;

          button.appendChild(img);
          button.appendChild(label);
          galleryThumbs.appendChild(button);
        });

        setGalleryImage(currentColour);
      }

      function syncPackMeta() {
        packSize = selections.length;
        packPrice = formatMoney(cartPreviewTotalCents());

        total.textContent = packPrice;
        drawerPrice.textContent = packPrice;

        packButtons.forEach(function (button) {
          var size = Number(button.dataset.packSize);
          button.classList.toggle("is-active", builderMode === "custom" && size === packSize);
        });
      }

      function renderBuilderMode() {
        var discovery = builderMode === "discovery";
        section.dataset.builderMode = builderMode;
        modeButtons.forEach(function (button) {
          var active = button.dataset.builderMode === builderMode;
          button.classList.toggle("is-active", active);
          button.setAttribute("aria-pressed", active ? "true" : "false");
        });
        if (customPacks) customPacks.hidden = discovery;
        if (discoveryPack) discoveryPack.hidden = !discovery;
        if (scentSelector) scentSelector.hidden = discovery;
        if (fixedScent) fixedScent.hidden = !discovery;
        if (discoveryList && !discoveryList.childElementCount) {
          discoveryScents.forEach(function (scent) {
            var badge = document.createElement("span");
            var icon = document.createElement("img");
            icon.src = getViffAromaIcon(scent);
            icon.alt = "";
            icon.width = 22;
            icon.height = 22;
            badge.appendChild(icon);
            badge.appendChild(document.createTextNode(scent));
            discoveryList.appendChild(badge);
          });
        }
      }

      function switchBuilderMode(mode) {
        if (mode === builderMode || (mode !== "custom" && mode !== "discovery")) return;
        savedModes[builderMode] = { selections: selections.map(function (selection) {
          return { aroma: selection.aroma, colour: selection.colour };
        }), currentIndex: currentIndex };
        builderMode = mode;
        if (savedModes[mode]) {
          selections = savedModes[mode].selections.map(function (selection) {
            return { aroma: selection.aroma, colour: selection.colour };
          });
          currentIndex = savedModes[mode].currentIndex;
        } else if (mode === "discovery") {
          selections = discoveryScents.map(function (scent) {
            var colour = colourOrder.find(function (candidate) {
              var variant = getVariant(scent, candidate);
              return variant && variant.available;
            }) || defaultColour;
            return { aroma: scent, colour: colour };
          });
          currentIndex = 0;
        } else {
          resetSelections(3);
        }
        drawerMode = "preview";
        render();
      }

      function resetSelections(size) {
        selections = [];

        for (var i = 0; i < size; i++) {
          selections.push({
            aroma: defaultAroma,
            colour: defaultColour
          });
        }

        currentIndex = 0;
        syncPackMeta();
      }

      function renderProgress() {
        if (!progress) return;

        progress.innerHTML = "";

        for (var i = 0; i < selections.length; i++) {
          var selected = selections[i] || {};
          var aroma = selected.aroma || defaultAroma;
          var colour = selected.colour || defaultColour;

          var dot = document.createElement("button");
          dot.type = "button";
          dot.className =
            "viff-progress-pill " +
            getViffColourClass(colour) +
            (i === currentIndex ? " is-active" : "");

          dot.setAttribute("data-step-index", i);

          if (aroma && colour) {
            dot.classList.add("is-done");
          }

          dot.innerHTML =
            '<span class="viff-progress-pill__title">Stick ' + (i + 1) + '</span>' +
            '<span class="viff-progress-pill__meta">' +
              '<span class="viff-progress-pill__icon-wrap">' +
                '<img class="viff-progress-pill__icon" src="' + getViffAromaIcon(aroma) + '" alt="' + aroma + ' icon">' +
              '</span>' +
              '<span class="viff-progress-pill__aroma">' + aroma + '</span>' +
              '<span class="viff-progress-pill__dot"></span>' +
              '<span class="viff-progress-pill__colour-dot"></span>' +
              '<span class="viff-progress-pill__colour">' + colour + '</span>' +
            '</span>';

          progress.appendChild(dot);
        }
      }

      function renderCurrentStick() {
        if (!selections[currentIndex]) {
          currentIndex = Math.max(0, selections.length - 1);
        }

        var current = selections[currentIndex];

        currentSmall.textContent = "Stick " + (currentIndex + 1) + " of " + selections.length;
        currentTitle.textContent = builderMode === "discovery" ? "Choose " + current.aroma + "’s colour" : "Build Stick " + (currentIndex + 1);
        if (fixedScentIcon) fixedScentIcon.src = getViffAromaIcon(current.aroma);
        if (fixedScentName) fixedScentName.textContent = current.aroma;

        aromaButtons.forEach(function (button) {
          button.classList.toggle("is-selected", button.dataset.aroma === current.aroma);
          button.disabled = builderMode === "discovery";
        });

        colourButtons.forEach(function (button) {
          button.classList.toggle("is-selected", button.dataset.colour === current.colour);
        });

        prevButton.style.display = currentIndex === 0 ? "none" : "block";
        nextButton.textContent = currentIndex === selections.length - 1 ? "Review pack" : "Next stick";
      }

      function renderSummary() {
        summary.innerHTML = "";
        syncPackMeta();

        for (var i = 0; i < selections.length; i++) {
          var line = document.createElement("div");
          var text = document.createElement("span");
          var edit = document.createElement("button");

          line.className = "viff-summary-line";
          text.innerHTML =
            "<strong>" + (builderMode === "discovery" ? 1 : i + 1) + "x</strong> " +
            selections[i].aroma + " / " + selections[i].colour;

          edit.type = "button";
          edit.textContent = "Edit";
          edit.setAttribute("data-edit-stick", i);

          line.appendChild(text);
          line.appendChild(edit);
          summary.appendChild(line);
        }
      }

      function validateSelections() {
        var errors = [];
        var neededByVariant = {};

        if (!variants.length) {
          errors.push("No variants loaded. Check the product handle at the top of the code.");
          return errors;
        }

        for (var i = 0; i < selections.length; i++) {
          var selected = selections[i];
          var variant = getVariant(selected.aroma, selected.colour);

          if (!variant) {
            errors.push("Stick " + (i + 1) + ": variant not found");
            continue;
          }

          if (!variant.available) {
            errors.push("Stick " + (i + 1) + ": " + selected.aroma + " / " + selected.colour + " is sold out");
            continue;
          }

          var variantId = String(variant.id);

          if (!neededByVariant[variantId]) {
            neededByVariant[variantId] = {
              variant: variant,
              count: 0,
              label: selected.colour
            };
          }

          neededByVariant[variantId].count += 1;
        }

        Object.keys(neededByVariant).forEach(function (variantId) {
          var item = neededByVariant[variantId];
          var variant = item.variant;

          var tracksInventory =
            variant.inventoryManagement !== null &&
            variant.inventoryManagement !== "" &&
            typeof variant.inventoryManagement !== "undefined";

          var deniesOversell = variant.inventoryPolicy !== "continue";
          var inventoryQuantity = Number(variant.inventoryQuantity);

          if (
            tracksInventory &&
            deniesOversell &&
            !Number.isNaN(inventoryQuantity) &&
            item.count > inventoryQuantity
          ) {
            errors.push(
              item.label + " only has " + inventoryQuantity + " in stock. Reduce the quantity or choose another colour."
            );
          }
        });

        return errors;
      }

      function updateAvailabilityUI() {
        var errors = validateSelections();
        var hasErrors = errors.length > 0;

        atcButton.disabled = hasErrors;
        drawerCheckout.disabled = hasErrors;

        if (hasErrors) {
          atcButton.textContent = "Sold out";
          message.textContent = errors[0];

          if (drawerMode === "preview") {
            drawerStatus.textContent = errors[0];
            drawerCheckout.textContent = "Sold out";
          }
        } else {
          atcButton.textContent = "Add to cart";
          if (builderMode === "discovery" && !discoveryReady) {
            atcButton.disabled = true;
            atcButton.textContent = "Coming soon";
            message.textContent = "Your discovery pack will be available soon.";
            if (drawerMode === "preview") {
              drawerCheckout.disabled = true;
              drawerCheckout.textContent = "Coming soon";
              drawerStatus.textContent = "Your discovery pack will be available soon.";
            }
            return;
          }

          if (drawerMode === "preview") {
            message.textContent = "Have a discount code? You can apply it at checkout.";
            drawerStatus.textContent = "Review your pack before checkout.";
            drawerCheckout.textContent = "Checkout";
          }
        }
      }

      function renderPreviewDrawer() {
        drawerMode = "preview";
        drawerLines.innerHTML = "";

        syncPackMeta();

        drawerPriceLabel.textContent = "Subtotal";
        drawerPrice.textContent = packPrice;

        drawerPill.textContent = "pack";
        drawerTitle.textContent = builderMode === "discovery" ? "Meet the scents" : "Your pack";
        drawerStatus.textContent = "Review your pack before checkout.";
        drawerNote.textContent = "Have a discount code? You can apply it at checkout.";
        drawerAdd.style.display = "none";
        drawerCheckout.disabled = false;
        drawerCheckout.textContent = "Checkout";
        drawerSecondary.textContent = "Keep editing";

        for (var i = 0; i < selections.length; i++) {
          var selected = selections[i];
          var variant = getVariant(selected.aroma, selected.colour);
          var image = "";

          if (variant && variant.image) {
            image = variant.image;
          } else if (productData.featuredImage) {
            image = productData.featuredImage;
          }

          var isFree = lineIsFree(i, selections.length);
          var finalPrice = lineFinalPrice(i, selections.length);

          var line = document.createElement("div");
          line.className = "viff-cart-drawer__line";

          var imageWrap = document.createElement("div");
          imageWrap.className = "viff-cart-drawer__image";

          if (image) {
            var img = document.createElement("img");
            img.src = cleanImage(image);
            img.alt = selected.aroma + " " + selected.colour + " viff pocket inhaler";
            imageWrap.appendChild(img);
          }

          var main = document.createElement("div");
          main.className = "viff-cart-drawer__line-main";

          var top = document.createElement("div");
          top.className = "viff-cart-drawer__line-top";

          var title = document.createElement("strong");
          title.className = "viff-cart-drawer__line-title";
          title.textContent = "viff pocket inhaler";

          var price = document.createElement("span");
          price.className = "viff-cart-drawer__line-price";

          if (isFree) {
            price.innerHTML =
              "<s>" + formatMoney(FULL_PRICE_CENTS) + "</s>" +
              "<strong class='is-free'>" + formatMoney(0) + "</strong>";
          } else {
            price.innerHTML = "<strong>" + formatMoney(finalPrice) + "</strong>";
          }

          var meta = document.createElement("span");
          meta.className = "viff-cart-drawer__line-meta";
          meta.textContent =
            "Stick " + (i + 1) +
            " • Scent: " + selected.aroma +
            " • Colour: " + selected.colour;

          if (isFree) {
            var freeTag = document.createElement("span");
            freeTag.className = "viff-cart-drawer__free-tag";
            freeTag.textContent = selections.length >= 5 ? "Buy 3, get 2 free" : "Buy 2, get 1 free";
            meta.appendChild(document.createElement("br"));
            meta.appendChild(freeTag);
          }

          var bottom = document.createElement("div");
          bottom.className = "viff-cart-drawer__line-bottom";

          var qtyControls = document.createElement("div");
          qtyControls.className = "viff-cart-drawer__qty-controls";

          var minus = document.createElement("button");
          minus.type = "button";
          minus.textContent = "−";
          minus.setAttribute("data-preview-minus", i);
          minus.disabled = selections.length <= 1;

          var qty = document.createElement("span");

          if (!variant) {
            qty.textContent = "Not found";
          } else if (!variant.available) {
            qty.textContent = "Sold out";
          } else {
            qty.textContent = "1";
          }

          var plus = document.createElement("button");
          plus.type = "button";
          plus.textContent = "+";
          plus.setAttribute("data-preview-plus", i);
          plus.disabled = selections.length >= MAX_STICKS;

          qtyControls.appendChild(minus);
          qtyControls.appendChild(qty);
          qtyControls.appendChild(plus);

          var remove = document.createElement("button");
          remove.type = "button";
          remove.className = "viff-cart-drawer__remove";
          remove.textContent = "Delete";
          remove.setAttribute("data-preview-delete", i);
          remove.disabled = selections.length <= 1;

          top.appendChild(title);
          top.appendChild(price);

          if (builderMode === "discovery") {
            bottom.textContent = "1 stick included";
          } else {
            bottom.appendChild(qtyControls);
            bottom.appendChild(remove);
          }

          main.appendChild(top);
          main.appendChild(meta);
          main.appendChild(bottom);

          line.appendChild(imageWrap);
          line.appendChild(main);

          drawerLines.appendChild(line);
        }
      }

      function renderRealCart(cart) {
        drawerMode = "cart";
        drawerLines.innerHTML = "";

        var itemCount = Number(cart.item_count || 0);

        updateCartBubble(itemCount);

        drawerPill.textContent = "cart";
        drawerTitle.textContent = itemCount > 0 ? "Your cart" : "Cart";
        drawerStatus.textContent = itemCount === 1 ? "1 item ready for checkout." : itemCount + " items ready for checkout.";
        drawerPriceLabel.textContent = "Subtotal";
        drawerPrice.textContent = formatMoney(cart.total_price);
        drawerNote.textContent = "Discount codes can be used at checkout.";
        drawerAdd.style.display = "none";
        drawerCheckout.textContent = "Checkout";
        drawerSecondary.textContent = itemCount > 0 ? "Empty cart" : "Keep shopping";

        if (!itemCount) {
          var empty = document.createElement("div");
          empty.className = "viff-cart-drawer__empty";
          empty.innerHTML =
            "<strong>Your cart is empty.</strong><br>" +
            "<span>Build a pack and it will show here.</span>";
          drawerLines.appendChild(empty);
          drawerCheckout.disabled = true;
          return;
        }

        drawerCheckout.disabled = false;

        (cart.items || []).forEach(function (item) {
          var props = item.properties || {};
          var metaParts = [];

          if (props.Pack) metaParts.push(props.Pack);
          if (props.Stick) metaParts.push(props.Stick);
          if (props.Aroma) metaParts.push("Scent: " + props.Aroma);
          if (props.Colour) metaParts.push("Colour: " + props.Colour);

          var linePrice = Number(item.line_price || 0);
          var finalLinePrice = Number(item.final_line_price || linePrice);
          var hasDiscount = linePrice > finalLinePrice;

          var line = document.createElement("div");
          line.className = "viff-cart-drawer__line";

          var imageWrap = document.createElement("div");
          imageWrap.className = "viff-cart-drawer__image";

          if (item.image) {
            var img = document.createElement("img");
            img.src = cleanImage(item.image);
            img.alt = item.product_title || item.title || "Cart item";
            imageWrap.appendChild(img);
          }

          var main = document.createElement("div");
          main.className = "viff-cart-drawer__line-main";

          var top = document.createElement("div");
          top.className = "viff-cart-drawer__line-top";

          var title = document.createElement("strong");
          title.className = "viff-cart-drawer__line-title";
          title.textContent = item.product_title || item.title || "viff pocket inhaler";

          var price = document.createElement("span");
          price.className = "viff-cart-drawer__line-price";

          if (hasDiscount) {
            price.innerHTML =
              "<s>" + formatMoney(linePrice) + "</s>" +
              "<strong class='is-free'>" + formatMoney(finalLinePrice) + "</strong>";
          } else {
            price.innerHTML = "<strong>" + formatMoney(finalLinePrice) + "</strong>";
          }

          var meta = document.createElement("span");
          meta.className = "viff-cart-drawer__line-meta";
          meta.textContent = metaParts.join(" • ") || item.variant_title || "";

          var bottom = document.createElement("div");
          bottom.className = "viff-cart-drawer__line-bottom";

          var qtyControls = document.createElement("div");
          qtyControls.className = "viff-cart-drawer__qty-controls";

          var minus = document.createElement("button");
          minus.type = "button";
          minus.textContent = "−";
          minus.setAttribute("data-cart-minus", item.key);
          minus.setAttribute("data-cart-qty", item.quantity);
          minus.disabled = Number(item.quantity) <= 1;

          var qty = document.createElement("span");
          qty.textContent = item.quantity;

          var plus = document.createElement("button");
          plus.type = "button";
          plus.textContent = "+";
          plus.setAttribute("data-cart-plus", item.key);
          plus.setAttribute("data-cart-qty", item.quantity);

          qtyControls.appendChild(minus);
          qtyControls.appendChild(qty);
          qtyControls.appendChild(plus);

          var remove = document.createElement("button");
          remove.type = "button";
          remove.className = "viff-cart-drawer__remove";
          remove.textContent = "Delete";
          remove.setAttribute("data-remove-line", item.key);

          top.appendChild(title);
          top.appendChild(price);

          bottom.appendChild(qtyControls);
          bottom.appendChild(remove);

          main.appendChild(top);
          main.appendChild(meta);
          main.appendChild(bottom);

          line.appendChild(imageWrap);
          line.appendChild(main);

          drawerLines.appendChild(line);
        });
      }

      function refreshRealCartDrawer() {
        drawerLines.innerHTML = "";

        var loading = document.createElement("div");
        loading.className = "viff-cart-drawer__empty";
        loading.innerHTML = "<strong>Loading cart...</strong><br><span>One sec.</span>";
        drawerLines.appendChild(loading);

        return fetchCart()
          .then(function (cart) {
            renderRealCart(cart);
            return cart;
          })
          .catch(function () {
            drawerStatus.textContent = "Could not load cart. Please refresh and try again.";
          });
      }

      function render() {
        renderBuilderMode();
        syncPackMeta();
        renderProgress();
        renderCurrentStick();
        renderSummary();
        renderGallery();

        if (drawerMode === "cart") {
          refreshRealCartDrawer();
        } else {
          renderPreviewDrawer();
        }

        updateAvailabilityUI();
      }

      function openDrawer(mode) {
        drawer.classList.add("is-open");
        drawer.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";

        if (mode === "cart") {
          drawerMode = "cart";
          return refreshRealCartDrawer();
        }

        drawerMode = "preview";
        renderPreviewDrawer();
        updateAvailabilityUI();
      }

      function closeDrawer() {
        drawer.classList.remove("is-open");
        drawer.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      }

      function buildCartItems() {
        var items = [];

        for (var i = 0; i < selections.length; i++) {
          var variant = getVariant(selections[i].aroma, selections[i].colour);

          if (variant) {
            items.push({
              id: Number(variant.id),
              quantity: 1,
              properties: {
  "Pack": selections.length + "-Pack",
  "Stick": "Stick " + (i + 1),
  "Aroma": selections[i].aroma,
  "Colour": selections[i].colour
}
            });
          }
        }

        if (builderMode === "discovery") {
          items.forEach(function (item) { item.properties["Pack type"] = "Meet the scents"; });
        }
        return items;
      }

      function setLoading(isLoading, text) {
        atcButton.disabled = isLoading;
        drawerAdd.disabled = isLoading;
        drawerCheckout.disabled = isLoading;

        if (isLoading) {
          atcButton.classList.add("is-clicked");
          atcButton.textContent = text || "Adding...";
          drawerAdd.textContent = text || "Adding...";
          drawerCheckout.textContent = text || "Adding...";
        } else {
  atcButton.classList.remove("is-clicked");
  atcButton.textContent = "Add to cart";
  drawerAdd.textContent = "Add pack to cart";
  drawerCheckout.textContent = "Checkout";
  updateAvailabilityUI();
}
      }

      function addPackToCart(goToCheckout) {
        if (builderMode === "discovery" && !discoveryReady) {
          message.textContent = "Your discovery pack will be available soon.";
          return;
        }
        var errors = validateSelections();

        if (errors.length > 0) {
          message.textContent = errors[0];
          drawerStatus.textContent = errors[0];
          openDrawer("preview");
          return;
        }

        var items = buildCartItems();

        if (!items.length) {
          message.textContent = "No valid items found. Check the variants.";
          drawerStatus.textContent = "No valid items found. Check the variants.";
          openDrawer("preview");
          return;
        }

        setLoading(true, "Adding...");

        fetch(cartUrl("/cart/add.js"), {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error(data.description || data.message || "Cart add failed");
              });
            }

            return response.json();
          })
          .then(function () {
            return fetchCart();
          })
          .then(function (cart) {
            drawerMode = "cart";
            setLoading(false);
            message.textContent = "Added to cart.";

            updateCartBubble(Number(cart.item_count || 0));
            renderRealCart(cart);

            try {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              document.dispatchEvent(new CustomEvent("cart:updated"));
            } catch (error) {}

            if (goToCheckout) {
              window.location.href = cartUrl("/checkout");
            } else {
              drawer.classList.add("is-open");
              drawer.setAttribute("aria-hidden", "false");
              document.body.style.overflow = "hidden";
            }
          })
          .catch(function (error) {
            setLoading(false);

            var errorText = error && error.message
              ? error.message
              : "Something went wrong. Check product status, inventory, and variants.";

            message.textContent = errorText;
            drawerStatus.textContent = errorText;

            atcButton.disabled = true;
            atcButton.textContent = "Sold out";

            drawerCheckout.disabled = true;
            drawerCheckout.textContent = "Sold out";

            openDrawer("preview");
          });
      }

      function changeCartLine(lineKey, quantity) {
        drawerStatus.textContent = "Updating cart...";

        return fetch(cartUrl("/cart/change.js"), {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: quantity
          })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error(data.description || data.message || "Cart update failed");
              });
            }

            return response.json();
          })
          .then(function (cart) {
            renderRealCart(cart);
            updateCartBubble(Number(cart.item_count || 0));
          })
          .catch(function (error) {
            drawerStatus.textContent = error && error.message ? error.message : "Could not update cart.";
            refreshRealCartDrawer();
          });
      }

      function clearCart() {
        drawerStatus.textContent = "Emptying cart...";

        return fetch(cartUrl("/cart/clear.js"), {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Accept": "application/json"
          }
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Cart clear failed");
            return response.json();
          })
          .then(function (cart) {
            renderRealCart(cart);
            updateCartBubble(Number(cart.item_count || 0));
          })
          .catch(function () {
            drawerStatus.textContent = "Could not empty cart.";
            refreshRealCartDrawer();
          });
      }

      function addPreviewItem(afterIndex) {
        if (builderMode === "discovery") return;
        if (selections.length >= MAX_STICKS) return;

        var source = selections[afterIndex] || selections[selections.length - 1] || {
          aroma: defaultAroma,
          colour: defaultColour
        };

        selections.splice(afterIndex + 1, 0, {
          aroma: source.aroma,
          colour: source.colour
        });

        currentIndex = afterIndex + 1;
        drawerMode = "preview";
        render();
        openDrawer("preview");
      }

      function removePreviewItem(index) {
        if (builderMode === "discovery") return;
        if (selections.length <= 1) return;

        selections.splice(index, 1);

        if (currentIndex >= selections.length) {
          currentIndex = selections.length - 1;
        }

        drawerMode = "preview";
        render();
        openDrawer("preview");
      }

      modeButtons.forEach(function (button) {
        button.addEventListener("click", function () { switchBuilderMode(button.dataset.builderMode); });
      });

      packButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          if (builderMode !== "custom") return;
          var size = Number(button.dataset.packSize);
          resetSelections(size);
          drawerMode = "preview";
          message.textContent = "Have a discount code? You can apply it at checkout.";
          render();
        });
      });

      progress.addEventListener("click", function (event) {
        var dot = event.target.closest("[data-step-index]");
        if (!dot) return;

        currentIndex = Number(dot.getAttribute("data-step-index"));
        message.textContent = "";
        render();
      });

      aromaButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          if (builderMode === "discovery") return;
          selections[currentIndex].aroma = button.dataset.aroma;
          drawerMode = "preview";
          message.textContent = "Scent selected. Choose a colour, then tap next.";
          render();
        });
      });

      colourButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          selections[currentIndex].colour = button.dataset.colour;
          drawerMode = "preview";
          message.textContent = "Colour selected. Tap next when you are ready.";
          render();
        });
      });

      if (galleryThumbs) {
        galleryThumbs.addEventListener("click", function (event) {
          var button = event.target.closest("[data-gallery-colour]");
          if (!button) return;

          var colour = button.getAttribute("data-gallery-colour");
          selections[currentIndex].colour = colour;
          drawerMode = "preview";
          message.textContent = "Colour selected. Choose a scent, then tap next.";
          render();
        });
      }

      prevButton.addEventListener("click", function () {
        if (currentIndex > 0) {
          currentIndex = currentIndex - 1;
          message.textContent = "";
          render();
        }
      });

      nextButton.addEventListener("click", function () {
        if (currentIndex < selections.length - 1) {
          currentIndex = currentIndex + 1;
          message.textContent = "";
          render();
        } else {
          message.textContent = "Pack reviewed. Add it to cart when ready.";
          openDrawer("preview");
        }
      });

      reviewButton.addEventListener("click", function () {
        message.textContent = "Review your selected pack.";
        openDrawer("preview");
      });

      summary.addEventListener("click", function (event) {
        var editButton = event.target.closest("[data-edit-stick]");
        if (!editButton) return;

        currentIndex = Number(editButton.getAttribute("data-edit-stick"));
        drawerMode = "preview";
        message.textContent = "";
        render();
      });

      drawerLines.addEventListener("click", function (event) {
        var removeButton = event.target.closest("[data-remove-line]");
        if (removeButton) {
          changeCartLine(removeButton.getAttribute("data-remove-line"), 0);
          return;
        }

        var cartMinus = event.target.closest("[data-cart-minus]");
        if (cartMinus) {
          var minusQty = Number(cartMinus.getAttribute("data-cart-qty")) - 1;
          changeCartLine(cartMinus.getAttribute("data-cart-minus"), Math.max(0, minusQty));
          return;
        }

        var cartPlus = event.target.closest("[data-cart-plus]");
        if (cartPlus) {
          var plusQty = Number(cartPlus.getAttribute("data-cart-qty")) + 1;
          changeCartLine(cartPlus.getAttribute("data-cart-plus"), plusQty);
          return;
        }

        var previewMinus = event.target.closest("[data-preview-minus]");
        if (previewMinus) {
          removePreviewItem(Number(previewMinus.getAttribute("data-preview-minus")));
          return;
        }

        var previewPlus = event.target.closest("[data-preview-plus]");
        if (previewPlus) {
          addPreviewItem(Number(previewPlus.getAttribute("data-preview-plus")));
          return;
        }

        var previewDelete = event.target.closest("[data-preview-delete]");
        if (previewDelete) {
          removePreviewItem(Number(previewDelete.getAttribute("data-preview-delete")));
        }
      });

      closeDrawerButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          closeDrawer();
        });
      });

      drawerSecondary.addEventListener("click", function () {
        if (drawerMode === "cart") {
          clearCart();
        } else {
          closeDrawer();
        }
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          closeDrawer();
        }
      });

      document.addEventListener("click", function (event) {
        var clickedLink = event.target.closest("a");

        if (!clickedLink) return;
        if (event.target.closest("[data-viff-cart-drawer]")) return;

        var href = clickedLink.getAttribute("href") || "";
        var isNativeCartIcon = clickedLink.id === "cart-icon-bubble";
        var isCartLink =
          href === "/cart" ||
          href === cartUrl("/cart") ||
          href.indexOf("/cart?") === 0 ||
          href.indexOf("/cart/") === 0;

        if (isNativeCartIcon || isCartLink) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          openDrawer("cart");
        }
      }, true);

      atcButton.addEventListener("click", function () {
        addPackToCart(false);
      });

      drawerAdd.addEventListener("click", function () {
        addPackToCart(false);
      });

      drawerCheckout.addEventListener("click", function () {
        if (drawerMode === "cart") {
          window.location.href = cartUrl("/checkout");
        } else {
          addPackToCart(true);
        }
      });

      resetSelections(packSize);
      if (section.dataset.defaultMode === "discovery" || new URLSearchParams(window.location.search).get("pack") === "discovery") {
        switchBuilderMode("discovery");
      } else {
        render();
      }

      fetchCart()
        .then(function (cart) {
          updateCartBubble(Number(cart.item_count || 0));
        })
        .catch(function () {});
    });
  }

  initViffWizardMk3();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initViffWizardMk3);
  }

  document.addEventListener("shopify:section:load", initViffWizardMk3);
})();

